import React from 'react';
import { motion } from 'framer-motion';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart, BarChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  LineChart,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  CanvasRenderer
]);

const EarningsChart = ({ data, type = 'line', title = 'Earnings' }) => {
  const chartOptions = {
    title: {
      text: title,
      left: 'center'
    },
    tooltip: {
      trigger: 'axis',
      formatter: function(params) {
        const param = params[0];
        return `${param.name}<br/>Earnings: ${param.value.toFixed(2)} LEI`;
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: data.map(item => item.date),
      axisTick: {
        alignWithLabel: true
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value} LEI'
      }
    },
    series: [
      {
        name: 'Earnings',
        type: type,
        data: data.map(item => item.earnings),
        itemStyle: {
          color: '#22c55e'
        },
        lineStyle: {
          color: '#22c55e'
        }
      }
    ]
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <ReactEChartsCore
        echarts={echarts}
        option={chartOptions}
        style={{ height: '400px' }}
      />
    </motion.div>
  );
};

export default EarningsChart;